"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * ScriptLab Docs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.3.3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ScriptsApi = exports.ScriptsApiFactory = exports.ScriptsApiFp = exports.ScriptsApiAxiosParamCreator = exports.LockingApi = exports.LockingApiFactory = exports.LockingApiFp = exports.LockingApiAxiosParamCreator = exports.SupportedEvents = exports.InvocationResourceTypes = exports.InvocationLogLevel = exports.InvocationIncludeParams = void 0;
var axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
var common_1 = require("./common");
// @ts-ignore
var base_1 = require("./base");
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.InvocationIncludeParams = {
    Script: 'script'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.InvocationLogLevel = {
    Trace: 'TRACE',
    Debug: 'DEBUG',
    Info: 'INFO',
    Warning: 'WARNING',
    Error: 'ERROR'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.InvocationResourceTypes = {
    Order: 'order',
    Shipment: 'shipment'
};
/**
 * An enumeration.
 * @export
 * @enum {string}
 */
exports.SupportedEvents = {
    OrderCreated: 'order.created',
    ShipmentCreated: 'shipment.created',
    ShipmentUpdated: 'shipment.updated'
};
/**
 * LockingApi - axios parameter creator
 * @export
 */
var LockingApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Acquire Advisory Lock
         * @param {AcquireAdvisoryLockRequest} acquireAdvisoryLockRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acquireAdvisoryLockScriptsAdvisoryLocksAcquirePost: function (acquireAdvisoryLockRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([acquireAdvisoryLockRequest_1], args_1, true), void 0, function (acquireAdvisoryLockRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'acquireAdvisoryLockRequest' is not null or undefined
                            (0, common_1.assertParamExists)('acquireAdvisoryLockScriptsAdvisoryLocksAcquirePost', 'acquireAdvisoryLockRequest', acquireAdvisoryLockRequest);
                            localVarPath = "/scripts/advisory-locks/acquire";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(acquireAdvisoryLockRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Release Advisory Lock
         * @param {ReleaseAdvisoryLockRequest} releaseAdvisoryLockRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseAdvisoryLockScriptsAdvisoryLocksReleasePost: function (releaseAdvisoryLockRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([releaseAdvisoryLockRequest_1], args_1, true), void 0, function (releaseAdvisoryLockRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'releaseAdvisoryLockRequest' is not null or undefined
                            (0, common_1.assertParamExists)('releaseAdvisoryLockScriptsAdvisoryLocksReleasePost', 'releaseAdvisoryLockRequest', releaseAdvisoryLockRequest);
                            localVarPath = "/scripts/advisory-locks/release";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(releaseAdvisoryLockRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.LockingApiAxiosParamCreator = LockingApiAxiosParamCreator;
/**
 * LockingApi - functional programming interface
 * @export
 */
var LockingApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.LockingApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Acquire Advisory Lock
         * @param {AcquireAdvisoryLockRequest} acquireAdvisoryLockRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acquireAdvisoryLockScriptsAdvisoryLocksAcquirePost: function (acquireAdvisoryLockRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.acquireAdvisoryLockScriptsAdvisoryLocksAcquirePost(acquireAdvisoryLockRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LockingApi.acquireAdvisoryLockScriptsAdvisoryLocksAcquirePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Release Advisory Lock
         * @param {ReleaseAdvisoryLockRequest} releaseAdvisoryLockRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseAdvisoryLockScriptsAdvisoryLocksReleasePost: function (releaseAdvisoryLockRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.releaseAdvisoryLockScriptsAdvisoryLocksReleasePost(releaseAdvisoryLockRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['LockingApi.releaseAdvisoryLockScriptsAdvisoryLocksReleasePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.LockingApiFp = LockingApiFp;
/**
 * LockingApi - factory interface
 * @export
 */
var LockingApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.LockingApiFp)(configuration);
    return {
        /**
         *
         * @summary Acquire Advisory Lock
         * @param {LockingApiAcquireAdvisoryLockScriptsAdvisoryLocksAcquirePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acquireAdvisoryLockScriptsAdvisoryLocksAcquirePost: function (requestParameters, options) {
            return localVarFp.acquireAdvisoryLockScriptsAdvisoryLocksAcquirePost(requestParameters.acquireAdvisoryLockRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Release Advisory Lock
         * @param {LockingApiReleaseAdvisoryLockScriptsAdvisoryLocksReleasePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseAdvisoryLockScriptsAdvisoryLocksReleasePost: function (requestParameters, options) {
            return localVarFp.releaseAdvisoryLockScriptsAdvisoryLocksReleasePost(requestParameters.releaseAdvisoryLockRequest, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.LockingApiFactory = LockingApiFactory;
/**
 * LockingApi - object-oriented interface
 * @export
 * @class LockingApi
 * @extends {BaseAPI}
 */
var LockingApi = /** @class */ (function (_super) {
    __extends(LockingApi, _super);
    function LockingApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Acquire Advisory Lock
     * @param {LockingApiAcquireAdvisoryLockScriptsAdvisoryLocksAcquirePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LockingApi
     */
    LockingApi.prototype.acquireAdvisoryLockScriptsAdvisoryLocksAcquirePost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LockingApiFp)(this.configuration).acquireAdvisoryLockScriptsAdvisoryLocksAcquirePost(requestParameters.acquireAdvisoryLockRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Release Advisory Lock
     * @param {LockingApiReleaseAdvisoryLockScriptsAdvisoryLocksReleasePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LockingApi
     */
    LockingApi.prototype.releaseAdvisoryLockScriptsAdvisoryLocksReleasePost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.LockingApiFp)(this.configuration).releaseAdvisoryLockScriptsAdvisoryLocksReleasePost(requestParameters.releaseAdvisoryLockRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return LockingApi;
}(base_1.BaseAPI));
exports.LockingApi = LockingApi;
/**
 * ScriptsApi - axios parameter creator
 * @export
 */
var ScriptsApiAxiosParamCreator = function (configuration) {
    var _this = this;
    return {
        /**
         *
         * @summary Acquire Advisory Lock
         * @param {AcquireAdvisoryLockRequest} acquireAdvisoryLockRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acquireAdvisoryLockScriptsAdvisoryLocksAcquirePost: function (acquireAdvisoryLockRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([acquireAdvisoryLockRequest_1], args_1, true), void 0, function (acquireAdvisoryLockRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'acquireAdvisoryLockRequest' is not null or undefined
                            (0, common_1.assertParamExists)('acquireAdvisoryLockScriptsAdvisoryLocksAcquirePost', 'acquireAdvisoryLockRequest', acquireAdvisoryLockRequest);
                            localVarPath = "/scripts/advisory-locks/acquire";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(acquireAdvisoryLockRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Invocation
         * @param {CreateInvocation} createInvocation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvocationScriptsInvocationsPost: function (createInvocation_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createInvocation_1], args_1, true), void 0, function (createInvocation, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createInvocation' is not null or undefined
                            (0, common_1.assertParamExists)('createInvocationScriptsInvocationsPost', 'createInvocation', createInvocation);
                            localVarPath = "/scripts/invocations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createInvocation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Invocation
         * @param {CreateInvocation} createInvocation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvocationScriptsInvocationsPost_1: function (createInvocation_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createInvocation_1], args_1, true), void 0, function (createInvocation, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createInvocation' is not null or undefined
                            (0, common_1.assertParamExists)('createInvocationScriptsInvocationsPost_1', 'createInvocation', createInvocation);
                            localVarPath = "/scripts/invocations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createInvocation, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Script
         * @param {CreateScript} createScript
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScriptScriptsPost: function (createScript_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([createScript_1], args_1, true), void 0, function (createScript, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'createScript' is not null or undefined
                            (0, common_1.assertParamExists)('createScriptScriptsPost', 'createScript', createScript);
                            localVarPath = "/scripts";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(createScript, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Invocation Logs
         * @param {string} invocationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvocationLogsScriptsInvocationsInvocationIdLogsGet: function (invocationId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([invocationId_1], args_1, true), void 0, function (invocationId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'invocationId' is not null or undefined
                            (0, common_1.assertParamExists)('getInvocationLogsScriptsInvocationsInvocationIdLogsGet', 'invocationId', invocationId);
                            localVarPath = "/scripts/invocations/{invocation_id}/logs"
                                .replace("{".concat("invocation_id", "}"), encodeURIComponent(String(invocationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Invocation Logs
         * @param {string} invocationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvocationLogsScriptsInvocationsInvocationIdLogsGet_2: function (invocationId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([invocationId_1], args_1, true), void 0, function (invocationId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'invocationId' is not null or undefined
                            (0, common_1.assertParamExists)('getInvocationLogsScriptsInvocationsInvocationIdLogsGet_2', 'invocationId', invocationId);
                            localVarPath = "/scripts/invocations/{invocation_id}/logs"
                                .replace("{".concat("invocation_id", "}"), encodeURIComponent(String(invocationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List Invocations
         * @param {string} [webhookResourceId]
         * @param {InvocationResourceTypes} [webhookResourceType]
         * @param {boolean} [isMeaningful]
         * @param {Array<InvocationIncludeParams>} [include]
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvocationsScriptsInvocationsGet: function (webhookResourceId_1, webhookResourceType_1, isMeaningful_1, include_1, page_1, limit_1) {
            var args_1 = [];
            for (var _i = 6; _i < arguments.length; _i++) {
                args_1[_i - 6] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([webhookResourceId_1, webhookResourceType_1, isMeaningful_1, include_1, page_1, limit_1], args_1, true), void 0, function (webhookResourceId, webhookResourceType, isMeaningful, include, page, limit, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/scripts/invocations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (webhookResourceId !== undefined) {
                                localVarQueryParameter['webhook_resource_id'] = webhookResourceId;
                            }
                            if (webhookResourceType !== undefined) {
                                localVarQueryParameter['webhook_resource_type'] = webhookResourceType;
                            }
                            if (isMeaningful !== undefined) {
                                localVarQueryParameter['is_meaningful'] = isMeaningful;
                            }
                            if (include) {
                                localVarQueryParameter['include'] = include;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List Invocations
         * @param {string} [webhookResourceId]
         * @param {InvocationResourceTypes} [webhookResourceType]
         * @param {boolean} [isMeaningful]
         * @param {Array<InvocationIncludeParams>} [include]
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvocationsScriptsInvocationsGet_3: function (webhookResourceId_1, webhookResourceType_1, isMeaningful_1, include_1, page_1, limit_1) {
            var args_1 = [];
            for (var _i = 6; _i < arguments.length; _i++) {
                args_1[_i - 6] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([webhookResourceId_1, webhookResourceType_1, isMeaningful_1, include_1, page_1, limit_1], args_1, true), void 0, function (webhookResourceId, webhookResourceType, isMeaningful, include, page, limit, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/scripts/invocations";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (webhookResourceId !== undefined) {
                                localVarQueryParameter['webhook_resource_id'] = webhookResourceId;
                            }
                            if (webhookResourceType !== undefined) {
                                localVarQueryParameter['webhook_resource_type'] = webhookResourceType;
                            }
                            if (isMeaningful !== undefined) {
                                localVarQueryParameter['is_meaningful'] = isMeaningful;
                            }
                            if (include) {
                                localVarQueryParameter['include'] = include;
                            }
                            if (page !== undefined) {
                                localVarQueryParameter['page'] = page;
                            }
                            if (limit !== undefined) {
                                localVarQueryParameter['limit'] = limit;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary List Scripts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listScriptsScriptsGet: function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([], args_1, true), void 0, function (options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            localVarPath = "/scripts";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'GET' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Release Advisory Lock
         * @param {ReleaseAdvisoryLockRequest} releaseAdvisoryLockRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseAdvisoryLockScriptsAdvisoryLocksReleasePost: function (releaseAdvisoryLockRequest_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([releaseAdvisoryLockRequest_1], args_1, true), void 0, function (releaseAdvisoryLockRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'releaseAdvisoryLockRequest' is not null or undefined
                            (0, common_1.assertParamExists)('releaseAdvisoryLockScriptsAdvisoryLocksReleasePost', 'releaseAdvisoryLockRequest', releaseAdvisoryLockRequest);
                            localVarPath = "/scripts/advisory-locks/release";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(releaseAdvisoryLockRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Report Invocation Completed
         * @param {string} invocationId
         * @param {FinalizeInvocationRequest} finalizeInvocationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportInvocationCompletedScriptsInvocationsInvocationIdFinalizePost: function (invocationId_1, finalizeInvocationRequest_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([invocationId_1, finalizeInvocationRequest_1], args_1, true), void 0, function (invocationId, finalizeInvocationRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'invocationId' is not null or undefined
                            (0, common_1.assertParamExists)('reportInvocationCompletedScriptsInvocationsInvocationIdFinalizePost', 'invocationId', invocationId);
                            // verify required parameter 'finalizeInvocationRequest' is not null or undefined
                            (0, common_1.assertParamExists)('reportInvocationCompletedScriptsInvocationsInvocationIdFinalizePost', 'finalizeInvocationRequest', finalizeInvocationRequest);
                            localVarPath = "/scripts/invocations/{invocation_id}/finalize"
                                .replace("{".concat("invocation_id", "}"), encodeURIComponent(String(invocationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(finalizeInvocationRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Report Invocation Completed
         * @param {string} invocationId
         * @param {FinalizeInvocationRequest} finalizeInvocationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportInvocationCompletedScriptsInvocationsInvocationIdFinalizePost_4: function (invocationId_1, finalizeInvocationRequest_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([invocationId_1, finalizeInvocationRequest_1], args_1, true), void 0, function (invocationId, finalizeInvocationRequest, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'invocationId' is not null or undefined
                            (0, common_1.assertParamExists)('reportInvocationCompletedScriptsInvocationsInvocationIdFinalizePost_4', 'invocationId', invocationId);
                            // verify required parameter 'finalizeInvocationRequest' is not null or undefined
                            (0, common_1.assertParamExists)('reportInvocationCompletedScriptsInvocationsInvocationIdFinalizePost_4', 'finalizeInvocationRequest', finalizeInvocationRequest);
                            localVarPath = "/scripts/invocations/{invocation_id}/finalize"
                                .replace("{".concat("invocation_id", "}"), encodeURIComponent(String(invocationId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(finalizeInvocationRequest, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Shipwell Webhook Callback
         * @param {string} scriptId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellWebhookCallbackScriptsScriptCallbacksPost: function (scriptId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([scriptId_1], args_1, true), void 0, function (scriptId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'scriptId' is not null or undefined
                            (0, common_1.assertParamExists)('shipwellWebhookCallbackScriptsScriptCallbacksPost', 'scriptId', scriptId);
                            localVarPath = "/scripts/script-callbacks";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (scriptId !== undefined) {
                                localVarQueryParameter['script_id'] = scriptId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Shipwell Webhook Callback
         * @param {string} scriptId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellWebhookCallbackScriptsScriptCallbacksPost_5: function (scriptId_1) {
            var args_1 = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args_1[_i - 1] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([scriptId_1], args_1, true), void 0, function (scriptId, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'scriptId' is not null or undefined
                            (0, common_1.assertParamExists)('shipwellWebhookCallbackScriptsScriptCallbacksPost_5', 'scriptId', scriptId);
                            localVarPath = "/scripts/script-callbacks";
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'POST' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            if (scriptId !== undefined) {
                                localVarQueryParameter['script_id'] = scriptId;
                            }
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Script
         * @param {string} scriptId
         * @param {UpdateScript} updateScript
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScriptScriptsScriptIdPut: function (scriptId_1, updateScript_1) {
            var args_1 = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                args_1[_i - 2] = arguments[_i];
            }
            return __awaiter(_this, __spreadArray([scriptId_1, updateScript_1], args_1, true), void 0, function (scriptId, updateScript, options) {
                var localVarPath, localVarUrlObj, baseOptions, localVarRequestOptions, localVarHeaderParameter, localVarQueryParameter, headersFromBaseOptions;
                if (options === void 0) { options = {}; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            // verify required parameter 'scriptId' is not null or undefined
                            (0, common_1.assertParamExists)('updateScriptScriptsScriptIdPut', 'scriptId', scriptId);
                            // verify required parameter 'updateScript' is not null or undefined
                            (0, common_1.assertParamExists)('updateScriptScriptsScriptIdPut', 'updateScript', updateScript);
                            localVarPath = "/scripts/{script_id}"
                                .replace("{".concat("script_id", "}"), encodeURIComponent(String(scriptId)));
                            localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
                            if (configuration) {
                                baseOptions = configuration.baseOptions;
                            }
                            localVarRequestOptions = __assign(__assign({ method: 'PUT' }, baseOptions), options);
                            localVarHeaderParameter = {};
                            localVarQueryParameter = {};
                            // authentication APIKeyHeader required
                            return [4 /*yield*/, (0, common_1.setApiKeyToObject)(localVarHeaderParameter, "Authorization", configuration)];
                        case 1:
                            // authentication APIKeyHeader required
                            _a.sent();
                            localVarHeaderParameter['Content-Type'] = 'application/json';
                            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
                            headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
                            localVarRequestOptions.headers = __assign(__assign(__assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
                            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(updateScript, localVarRequestOptions, configuration);
                            return [2 /*return*/, {
                                    url: (0, common_1.toPathString)(localVarUrlObj),
                                    options: localVarRequestOptions,
                                }];
                    }
                });
            });
        },
    };
};
exports.ScriptsApiAxiosParamCreator = ScriptsApiAxiosParamCreator;
/**
 * ScriptsApi - functional programming interface
 * @export
 */
var ScriptsApiFp = function (configuration) {
    var localVarAxiosParamCreator = (0, exports.ScriptsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @summary Acquire Advisory Lock
         * @param {AcquireAdvisoryLockRequest} acquireAdvisoryLockRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acquireAdvisoryLockScriptsAdvisoryLocksAcquirePost: function (acquireAdvisoryLockRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.acquireAdvisoryLockScriptsAdvisoryLocksAcquirePost(acquireAdvisoryLockRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ScriptsApi.acquireAdvisoryLockScriptsAdvisoryLocksAcquirePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Invocation
         * @param {CreateInvocation} createInvocation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvocationScriptsInvocationsPost: function (createInvocation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createInvocationScriptsInvocationsPost(createInvocation, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ScriptsApi.createInvocationScriptsInvocationsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Invocation
         * @param {CreateInvocation} createInvocation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvocationScriptsInvocationsPost_1: function (createInvocation, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createInvocationScriptsInvocationsPost_1(createInvocation, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ScriptsApi.createInvocationScriptsInvocationsPost_1']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Create Script
         * @param {CreateScript} createScript
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScriptScriptsPost: function (createScript, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.createScriptScriptsPost(createScript, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ScriptsApi.createScriptScriptsPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Invocation Logs
         * @param {string} invocationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvocationLogsScriptsInvocationsInvocationIdLogsGet: function (invocationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getInvocationLogsScriptsInvocationsInvocationIdLogsGet(invocationId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ScriptsApi.getInvocationLogsScriptsInvocationsInvocationIdLogsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Get Invocation Logs
         * @param {string} invocationId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvocationLogsScriptsInvocationsInvocationIdLogsGet_2: function (invocationId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.getInvocationLogsScriptsInvocationsInvocationIdLogsGet_2(invocationId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ScriptsApi.getInvocationLogsScriptsInvocationsInvocationIdLogsGet_2']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary List Invocations
         * @param {string} [webhookResourceId]
         * @param {InvocationResourceTypes} [webhookResourceType]
         * @param {boolean} [isMeaningful]
         * @param {Array<InvocationIncludeParams>} [include]
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvocationsScriptsInvocationsGet: function (webhookResourceId, webhookResourceType, isMeaningful, include, page, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listInvocationsScriptsInvocationsGet(webhookResourceId, webhookResourceType, isMeaningful, include, page, limit, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ScriptsApi.listInvocationsScriptsInvocationsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary List Invocations
         * @param {string} [webhookResourceId]
         * @param {InvocationResourceTypes} [webhookResourceType]
         * @param {boolean} [isMeaningful]
         * @param {Array<InvocationIncludeParams>} [include]
         * @param {number} [page]
         * @param {number} [limit]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvocationsScriptsInvocationsGet_3: function (webhookResourceId, webhookResourceType, isMeaningful, include, page, limit, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listInvocationsScriptsInvocationsGet_3(webhookResourceId, webhookResourceType, isMeaningful, include, page, limit, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ScriptsApi.listInvocationsScriptsInvocationsGet_3']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary List Scripts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listScriptsScriptsGet: function (options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.listScriptsScriptsGet(options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ScriptsApi.listScriptsScriptsGet']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Release Advisory Lock
         * @param {ReleaseAdvisoryLockRequest} releaseAdvisoryLockRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseAdvisoryLockScriptsAdvisoryLocksReleasePost: function (releaseAdvisoryLockRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.releaseAdvisoryLockScriptsAdvisoryLocksReleasePost(releaseAdvisoryLockRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ScriptsApi.releaseAdvisoryLockScriptsAdvisoryLocksReleasePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Report Invocation Completed
         * @param {string} invocationId
         * @param {FinalizeInvocationRequest} finalizeInvocationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportInvocationCompletedScriptsInvocationsInvocationIdFinalizePost: function (invocationId, finalizeInvocationRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.reportInvocationCompletedScriptsInvocationsInvocationIdFinalizePost(invocationId, finalizeInvocationRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ScriptsApi.reportInvocationCompletedScriptsInvocationsInvocationIdFinalizePost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Report Invocation Completed
         * @param {string} invocationId
         * @param {FinalizeInvocationRequest} finalizeInvocationRequest
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportInvocationCompletedScriptsInvocationsInvocationIdFinalizePost_4: function (invocationId, finalizeInvocationRequest, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.reportInvocationCompletedScriptsInvocationsInvocationIdFinalizePost_4(invocationId, finalizeInvocationRequest, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ScriptsApi.reportInvocationCompletedScriptsInvocationsInvocationIdFinalizePost_4']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Shipwell Webhook Callback
         * @param {string} scriptId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellWebhookCallbackScriptsScriptCallbacksPost: function (scriptId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellWebhookCallbackScriptsScriptCallbacksPost(scriptId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ScriptsApi.shipwellWebhookCallbackScriptsScriptCallbacksPost']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Shipwell Webhook Callback
         * @param {string} scriptId
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellWebhookCallbackScriptsScriptCallbacksPost_5: function (scriptId, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.shipwellWebhookCallbackScriptsScriptCallbacksPost_5(scriptId, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ScriptsApi.shipwellWebhookCallbackScriptsScriptCallbacksPost_5']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
        /**
         *
         * @summary Update Script
         * @param {string} scriptId
         * @param {UpdateScript} updateScript
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScriptScriptsScriptIdPut: function (scriptId, updateScript, options) {
            return __awaiter(this, void 0, void 0, function () {
                var localVarAxiosArgs, localVarOperationServerIndex, localVarOperationServerBasePath;
                var _a, _b, _c;
                return __generator(this, function (_d) {
                    switch (_d.label) {
                        case 0: return [4 /*yield*/, localVarAxiosParamCreator.updateScriptScriptsScriptIdPut(scriptId, updateScript, options)];
                        case 1:
                            localVarAxiosArgs = _d.sent();
                            localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                            localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['ScriptsApi.updateScriptScriptsScriptIdPut']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                            return [2 /*return*/, function (axios, basePath) { return (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath); }];
                    }
                });
            });
        },
    };
};
exports.ScriptsApiFp = ScriptsApiFp;
/**
 * ScriptsApi - factory interface
 * @export
 */
var ScriptsApiFactory = function (configuration, basePath, axios) {
    var localVarFp = (0, exports.ScriptsApiFp)(configuration);
    return {
        /**
         *
         * @summary Acquire Advisory Lock
         * @param {ScriptsApiAcquireAdvisoryLockScriptsAdvisoryLocksAcquirePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acquireAdvisoryLockScriptsAdvisoryLocksAcquirePost: function (requestParameters, options) {
            return localVarFp.acquireAdvisoryLockScriptsAdvisoryLocksAcquirePost(requestParameters.acquireAdvisoryLockRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Invocation
         * @param {ScriptsApiCreateInvocationScriptsInvocationsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvocationScriptsInvocationsPost: function (requestParameters, options) {
            return localVarFp.createInvocationScriptsInvocationsPost(requestParameters.createInvocation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Invocation
         * @param {ScriptsApiCreateInvocationScriptsInvocationsPost0Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createInvocationScriptsInvocationsPost_1: function (requestParameters, options) {
            return localVarFp.createInvocationScriptsInvocationsPost_1(requestParameters.createInvocation, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Create Script
         * @param {ScriptsApiCreateScriptScriptsPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createScriptScriptsPost: function (requestParameters, options) {
            return localVarFp.createScriptScriptsPost(requestParameters.createScript, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Invocation Logs
         * @param {ScriptsApiGetInvocationLogsScriptsInvocationsInvocationIdLogsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvocationLogsScriptsInvocationsInvocationIdLogsGet: function (requestParameters, options) {
            return localVarFp.getInvocationLogsScriptsInvocationsInvocationIdLogsGet(requestParameters.invocationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Get Invocation Logs
         * @param {ScriptsApiGetInvocationLogsScriptsInvocationsInvocationIdLogsGet0Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getInvocationLogsScriptsInvocationsInvocationIdLogsGet_2: function (requestParameters, options) {
            return localVarFp.getInvocationLogsScriptsInvocationsInvocationIdLogsGet_2(requestParameters.invocationId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List Invocations
         * @param {ScriptsApiListInvocationsScriptsInvocationsGetRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvocationsScriptsInvocationsGet: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.listInvocationsScriptsInvocationsGet(requestParameters.webhookResourceId, requestParameters.webhookResourceType, requestParameters.isMeaningful, requestParameters.include, requestParameters.page, requestParameters.limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List Invocations
         * @param {ScriptsApiListInvocationsScriptsInvocationsGet0Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listInvocationsScriptsInvocationsGet_3: function (requestParameters, options) {
            if (requestParameters === void 0) { requestParameters = {}; }
            return localVarFp.listInvocationsScriptsInvocationsGet_3(requestParameters.webhookResourceId, requestParameters.webhookResourceType, requestParameters.isMeaningful, requestParameters.include, requestParameters.page, requestParameters.limit, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary List Scripts
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listScriptsScriptsGet: function (options) {
            return localVarFp.listScriptsScriptsGet(options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Release Advisory Lock
         * @param {ScriptsApiReleaseAdvisoryLockScriptsAdvisoryLocksReleasePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        releaseAdvisoryLockScriptsAdvisoryLocksReleasePost: function (requestParameters, options) {
            return localVarFp.releaseAdvisoryLockScriptsAdvisoryLocksReleasePost(requestParameters.releaseAdvisoryLockRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Report Invocation Completed
         * @param {ScriptsApiReportInvocationCompletedScriptsInvocationsInvocationIdFinalizePostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportInvocationCompletedScriptsInvocationsInvocationIdFinalizePost: function (requestParameters, options) {
            return localVarFp.reportInvocationCompletedScriptsInvocationsInvocationIdFinalizePost(requestParameters.invocationId, requestParameters.finalizeInvocationRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Report Invocation Completed
         * @param {ScriptsApiReportInvocationCompletedScriptsInvocationsInvocationIdFinalizePost0Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportInvocationCompletedScriptsInvocationsInvocationIdFinalizePost_4: function (requestParameters, options) {
            return localVarFp.reportInvocationCompletedScriptsInvocationsInvocationIdFinalizePost_4(requestParameters.invocationId, requestParameters.finalizeInvocationRequest, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Shipwell Webhook Callback
         * @param {ScriptsApiShipwellWebhookCallbackScriptsScriptCallbacksPostRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellWebhookCallbackScriptsScriptCallbacksPost: function (requestParameters, options) {
            return localVarFp.shipwellWebhookCallbackScriptsScriptCallbacksPost(requestParameters.scriptId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Shipwell Webhook Callback
         * @param {ScriptsApiShipwellWebhookCallbackScriptsScriptCallbacksPost0Request} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shipwellWebhookCallbackScriptsScriptCallbacksPost_5: function (requestParameters, options) {
            return localVarFp.shipwellWebhookCallbackScriptsScriptCallbacksPost_5(requestParameters.scriptId, options).then(function (request) { return request(axios, basePath); });
        },
        /**
         *
         * @summary Update Script
         * @param {ScriptsApiUpdateScriptScriptsScriptIdPutRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateScriptScriptsScriptIdPut: function (requestParameters, options) {
            return localVarFp.updateScriptScriptsScriptIdPut(requestParameters.scriptId, requestParameters.updateScript, options).then(function (request) { return request(axios, basePath); });
        },
    };
};
exports.ScriptsApiFactory = ScriptsApiFactory;
/**
 * ScriptsApi - object-oriented interface
 * @export
 * @class ScriptsApi
 * @extends {BaseAPI}
 */
var ScriptsApi = /** @class */ (function (_super) {
    __extends(ScriptsApi, _super);
    function ScriptsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @summary Acquire Advisory Lock
     * @param {ScriptsApiAcquireAdvisoryLockScriptsAdvisoryLocksAcquirePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScriptsApi
     */
    ScriptsApi.prototype.acquireAdvisoryLockScriptsAdvisoryLocksAcquirePost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ScriptsApiFp)(this.configuration).acquireAdvisoryLockScriptsAdvisoryLocksAcquirePost(requestParameters.acquireAdvisoryLockRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Invocation
     * @param {ScriptsApiCreateInvocationScriptsInvocationsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScriptsApi
     */
    ScriptsApi.prototype.createInvocationScriptsInvocationsPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ScriptsApiFp)(this.configuration).createInvocationScriptsInvocationsPost(requestParameters.createInvocation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Invocation
     * @param {ScriptsApiCreateInvocationScriptsInvocationsPost0Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScriptsApi
     */
    ScriptsApi.prototype.createInvocationScriptsInvocationsPost_1 = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ScriptsApiFp)(this.configuration).createInvocationScriptsInvocationsPost_1(requestParameters.createInvocation, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Create Script
     * @param {ScriptsApiCreateScriptScriptsPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScriptsApi
     */
    ScriptsApi.prototype.createScriptScriptsPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ScriptsApiFp)(this.configuration).createScriptScriptsPost(requestParameters.createScript, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Invocation Logs
     * @param {ScriptsApiGetInvocationLogsScriptsInvocationsInvocationIdLogsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScriptsApi
     */
    ScriptsApi.prototype.getInvocationLogsScriptsInvocationsInvocationIdLogsGet = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ScriptsApiFp)(this.configuration).getInvocationLogsScriptsInvocationsInvocationIdLogsGet(requestParameters.invocationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Get Invocation Logs
     * @param {ScriptsApiGetInvocationLogsScriptsInvocationsInvocationIdLogsGet0Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScriptsApi
     */
    ScriptsApi.prototype.getInvocationLogsScriptsInvocationsInvocationIdLogsGet_2 = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ScriptsApiFp)(this.configuration).getInvocationLogsScriptsInvocationsInvocationIdLogsGet_2(requestParameters.invocationId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List Invocations
     * @param {ScriptsApiListInvocationsScriptsInvocationsGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScriptsApi
     */
    ScriptsApi.prototype.listInvocationsScriptsInvocationsGet = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ScriptsApiFp)(this.configuration).listInvocationsScriptsInvocationsGet(requestParameters.webhookResourceId, requestParameters.webhookResourceType, requestParameters.isMeaningful, requestParameters.include, requestParameters.page, requestParameters.limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List Invocations
     * @param {ScriptsApiListInvocationsScriptsInvocationsGet0Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScriptsApi
     */
    ScriptsApi.prototype.listInvocationsScriptsInvocationsGet_3 = function (requestParameters, options) {
        var _this = this;
        if (requestParameters === void 0) { requestParameters = {}; }
        return (0, exports.ScriptsApiFp)(this.configuration).listInvocationsScriptsInvocationsGet_3(requestParameters.webhookResourceId, requestParameters.webhookResourceType, requestParameters.isMeaningful, requestParameters.include, requestParameters.page, requestParameters.limit, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary List Scripts
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScriptsApi
     */
    ScriptsApi.prototype.listScriptsScriptsGet = function (options) {
        var _this = this;
        return (0, exports.ScriptsApiFp)(this.configuration).listScriptsScriptsGet(options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Release Advisory Lock
     * @param {ScriptsApiReleaseAdvisoryLockScriptsAdvisoryLocksReleasePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScriptsApi
     */
    ScriptsApi.prototype.releaseAdvisoryLockScriptsAdvisoryLocksReleasePost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ScriptsApiFp)(this.configuration).releaseAdvisoryLockScriptsAdvisoryLocksReleasePost(requestParameters.releaseAdvisoryLockRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Report Invocation Completed
     * @param {ScriptsApiReportInvocationCompletedScriptsInvocationsInvocationIdFinalizePostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScriptsApi
     */
    ScriptsApi.prototype.reportInvocationCompletedScriptsInvocationsInvocationIdFinalizePost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ScriptsApiFp)(this.configuration).reportInvocationCompletedScriptsInvocationsInvocationIdFinalizePost(requestParameters.invocationId, requestParameters.finalizeInvocationRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Report Invocation Completed
     * @param {ScriptsApiReportInvocationCompletedScriptsInvocationsInvocationIdFinalizePost0Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScriptsApi
     */
    ScriptsApi.prototype.reportInvocationCompletedScriptsInvocationsInvocationIdFinalizePost_4 = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ScriptsApiFp)(this.configuration).reportInvocationCompletedScriptsInvocationsInvocationIdFinalizePost_4(requestParameters.invocationId, requestParameters.finalizeInvocationRequest, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Shipwell Webhook Callback
     * @param {ScriptsApiShipwellWebhookCallbackScriptsScriptCallbacksPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScriptsApi
     */
    ScriptsApi.prototype.shipwellWebhookCallbackScriptsScriptCallbacksPost = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ScriptsApiFp)(this.configuration).shipwellWebhookCallbackScriptsScriptCallbacksPost(requestParameters.scriptId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Shipwell Webhook Callback
     * @param {ScriptsApiShipwellWebhookCallbackScriptsScriptCallbacksPost0Request} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScriptsApi
     */
    ScriptsApi.prototype.shipwellWebhookCallbackScriptsScriptCallbacksPost_5 = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ScriptsApiFp)(this.configuration).shipwellWebhookCallbackScriptsScriptCallbacksPost_5(requestParameters.scriptId, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    /**
     *
     * @summary Update Script
     * @param {ScriptsApiUpdateScriptScriptsScriptIdPutRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ScriptsApi
     */
    ScriptsApi.prototype.updateScriptScriptsScriptIdPut = function (requestParameters, options) {
        var _this = this;
        return (0, exports.ScriptsApiFp)(this.configuration).updateScriptScriptsScriptIdPut(requestParameters.scriptId, requestParameters.updateScript, options).then(function (request) { return request(_this.axios, _this.basePath); });
    };
    return ScriptsApi;
}(base_1.BaseAPI));
exports.ScriptsApi = ScriptsApi;
